function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs3411"
});

var _ref3 = /*#__PURE__*/React.createElement("metadata", {
  id: "metadata3414"
});

function SvgMastercardLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg3409",
    viewBox: "0 0 1000.008 618.03103",
    height: 618.03101,
    width: 1000.008,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.3557321,0,0,3.3557321,-1551.7864,-2007.0469)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.5579399,0,0,2.5579399,884.90115,-11.427398)",
    id: "g13"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-502.86126,-22.613497)",
    id: "XMLID_328_"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#ff5f00"
    },
    id: "rect19",
    height: 56.599998,
    width: 31.5,
    className: "st1",
    y: 268.60001,
    x: 380.20001
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#eb001b"
    },
    d: "m 382.2,296.9 c 0,-11.5 5.4,-21.7 13.7,-28.3 -6.1,-4.8 -13.8,-7.7 -22.2,-7.7 -19.9,0 -36,16.1 -36,36 0,19.9 16.1,36 36,36 8.4,0 16.1,-2.9 22.2,-7.7 -8.3,-6.5 -13.7,-16.8 -13.7,-28.3 z",
    className: "st2",
    id: "XMLID_330_"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f79e1b"
    },
    id: "path22",
    d: "m 454.2,296.9 c 0,19.9 -16.1,36 -36,36 -8.4,0 -16.1,-2.9 -22.2,-7.7 8.4,-6.6 13.7,-16.8 13.7,-28.3 0,-11.5 -5.4,-21.7 -13.7,-28.3 6.1,-4.8 13.8,-7.7 22.2,-7.7 19.9,0 36,16.2 36,36 z",
    className: "st3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardLogo);
export default __webpack_public_path__ + "static/media/mastercard-logo.cd0668ee.svg";
export { ForwardRef as ReactComponent };